module.exports = __webpack_public_path__ + "static/media/fa-question.dd1ad991.png";